<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <div class="flex items-center justify-between ivu-mt" style="margin-bottom:8px;">
        <div class="flex items-center">
          <p>场所类型：</p>
          <el-row>
            <el-button type="info" :class="{active:search_data.type_id==''?true:false}" plain @click="placetype(1)" v-model="search_data.type">全部</el-button>
            <el-button type="info" :class="{active:search_data.type_id==item.id?true:false}" plain v-for="item in place_type_list" :key="item.id" @click="placetype(item.id)" v-model="search_data.type" v-show="item.id!=1">{{item.name}}</el-button>
          </el-row>
        </div>
      </div>
      <!-- <l-auth-button type="info" auth="hidden_danger_tracking_btn" @click="exportExcel" :loading="export_loading"> 导出EXCEL </l-auth-button> -->
      <div class="l-simple-search-container">
        <el-input placeholder="请输入责任人姓名" v-model="search_data.name" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div>
    </div>
    <l-table :span-method="objectSpanMethod" :data="data" v-loading="loading" row-key="id">
      <el-table-column prop="community_name" label="牵头单位" width="150">
        
        <template slot-scope="{ row }">
          <a class="link-color" @click="dangerInfo(row.community_name,row.type_name)">{{ row.community_name }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="type_name" label="场所类型" min-width="250"> </el-table-column>
      <el-table-column prop="state" label="隐患等级" width="100">
        <template slot-scope="{ row }">
          <el-tag type="danger" size="small" disable-transitions>{{ LEVEL[row.state] }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="user_name" label="责任人" min-width="100"> </el-table-column>
      <el-table-column prop="user_iphone" label="电话" min-width="150"> </el-table-column>
      <el-table-column prop="hidden_count" label="隐患数" min-width="100"> 
        <template slot-scope="{ row }">
          <a class="link-color" @click="dangerInfo(row.community_name,row.type_name,row.state)">{{ row.hidden_count }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="rectification_count" label="已整改隐患数" min-width="100"> 
        <template slot-scope="{ row }">
          <a class="link-color" @click="dangerInfo(row.community_name,row.type_name,row.state,1)">{{ row.rectification_count }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="hidden_rate" label="场所整改进度（%）" min-width="100"> </el-table-column>
     
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>


    <!--隐患清单-->
    <l-dialog :visible.sync="danger_info_visible" title="隐患清单" width="1600px">
      <l-danger-list-info :visible.sync="danger_info_visible" is-info :search-data="info_search_data"/>
    </l-dialog>



    
  </el-card>
</template>

<script>

import { LEVEL } from '../rental/rental';
import Info from "./Info.vue";
import Vue from "vue";
export default {
  components: {

    [Info.name]: Info,
  },
  data() {
    return {
      LEVEL:LEVEL,
      data: [
      ],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      export_loading:false,
      change_state_loading: [],

      add_visible: false, //是否显示添加
      edit_visible: false, //是否显示编辑
      edit_id: 0,
      info_id: 0,
      info_search_data:{},
      //搜索
      search_visible: false,
      search_data: {
        name: "",
        type_id : '',
      },
      rel_search_data:{
            
      },
      
      show_more_search: false,

      danger_info_visible:false,//隐患清单弹出

    };
  },
  computed:{
    place_type_list(){
      return this.$store.state.list.place_type_list
    },
  },

  mounted() {
   this.getList();

  },

  methods: {
    
    //打开隐患清单
    dangerInfo(unit,type,lavel,modify_type) {
      this.info_search_data.lead_unit = unit;
      this.info_search_data.place_type = type;
      this.info_search_data.danger_lavel = lavel||'';
      this.info_search_data.modify_type = modify_type||'';
      this.$nextTick(() => {
        this.danger_info_visible = true;
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
       console.log(row,column)
        if (columnIndex === 0 ||columnIndex === 1) {
          if (rowIndex % 4 === 0) {
            return {
              rowspan: 4,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
    //通过类型筛选
    placetype(id) {
      this.search_data.type_id = id;
      this.rel_search_data = this.search_data;
      this.getList();
    },
    
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("hiddenTracking_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //导出
    exportExcel(){
      this.export_loading = true;
      this.$_invoke('hiddenTracking_excel', { ...this.search_data })
        .then((ret) => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });
    },


    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },

    //显示修改密码界面
    showChangePwd(id) {
      this.change_pwd_id = id;
      this.$nextTick(() => {
        this.show_change_pwd = true;
      });
    },

    //修改密码成功回调
    onChangePwdSuccess() {
      this.show_change_pwd = false;
    },

    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`checkSpecs_del`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style scoped>
 .l-simple-search-container{
    float: right;
}
</style>
